module.exports = __webpack_public_path__ + "img/web-technology.5081e3fa.png";